module.exports = __webpack_public_path__ + "img/userlinks_stackoverflow.com.557ddd28.svg";